import { useSnackbarContext } from '@/contexts/SnackbarContext';
import { NotificationOptions, NotificationType, SnackbarLinkAction } from '@/types/notification';

interface UseSnackbarNotificationReturn {
  snackbarOpen: boolean;
  snackbarMessage: string;
  snackbarType: NotificationType;
  snackbarLink?: SnackbarLinkAction;
  showSuccess: (message: string, options?: NotificationOptions) => void;
  showError: (message: string, options?: NotificationOptions) => void;
  showWarning: (message: string, options?: NotificationOptions) => void;
  showInfo: (message: string, options?: NotificationOptions) => void;
  closeSnackbar: () => void;
}

/**
 * Hook to access snackbar notifications
 * Provides a convenient wrapper around the SnackbarContext
 */
export const useSnackbarNotification = (): UseSnackbarNotificationReturn => {
  return useSnackbarContext();
};
